import React from 'react'
import { useGetAssignmentsQuery } from "../../features/assignment/assignment.Api";
import SkeletonLoader from '../../components/ui/SkeletonLoader';
import AssignmentItem from '../../components/AssignmentItem';
import { useDispatch } from 'react-redux';
import { assignmentAddModal } from '../../features/assignment/assignmentSlice';
import AddAssignment from '../../components/AddAssignment';
import Layout from '../../components/Layout';


export default function Assignment() {
    const dispatch = useDispatch()
    const { isSuccess: isSuccessFetchAssignments, data: assignments, isLoading: isLoadingFetchAssignments } = useGetAssignmentsQuery()

    let content;

    if (isLoadingFetchAssignments) {
        content = <SkeletonLoader />
    }
    else if (isSuccessFetchAssignments && assignments?.length > 0) {
        content = assignments.map(assignment => <AssignmentItem key={assignment.id} assignment={assignment} />)
    } else if (isSuccessFetchAssignments && assignments.length === 0) {
        content = <h2 className='text-2xl'>No assignment here.</h2>
    } else {
        content = <h2 className='text-2xl'>Something is wrong.</h2>
    }

    return (
        <Layout>
            <section className="py-6 bg-primary">
                <div className="mx-auto max-w-full px-5 lg:px-20">
                    <AddAssignment />
                    <div className="px-3 py-20 bg-opacity-10">
                        <div className="w-full flex">
                            <button onClick={() => dispatch(assignmentAddModal())} className="btn ml-auto">Add Assignment</button>
                        </div>
                        <div className="overflow-x-auto mt-4">
                            <table className="divide-y-1 text-base divide-gray-600 w-full">
                                <thead>
                                    <tr>
                                        <th className="table-th">Title</th>
                                        <th className="table-th">Video Title</th>
                                        <th className="table-th">Mark</th>
                                        <th className="table-th">Action</th>
                                    </tr>
                                </thead>

                                <tbody className="divide-y divide-slate-600/50">
                                    {content}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}
